module.exports = __webpack_public_path__ + "static/media/PK.7c72f8bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/galaxyRewards/PK.png
// module id = 2062
// module chunks = 0